// 3rd
import Swiper, { Pagination } from 'swiper';

const paragraphTestimonial = [
  ...document.querySelectorAll('.paragraph--testimonial'),
];

const initSwiper = () => {
  paragraphTestimonial.forEach((testimonial) => {
    const slides = [
      ...testimonial.querySelectorAll('.paragraph-testimonial__field-item'),
    ];

    if (slides.length > 1) {
      new Swiper(testimonial, {
        loop: true,
        modules: [Pagination],
        pagination: {
          clickable: true,
          el: '.swiper-pagination',
          type: 'bullets',
        },
        watchOverflow: true,
      });
    }
  });
};

(() => {
  if (paragraphTestimonial.length > 0) {
    initSwiper();
  }
})();
